<template>
    <PrimeDataTable
      :title="'Udfs'"
      :showFilter="true"
      :searchOption="true"
      :selectAll="true"
      :showDownload="true"
      :showUpload="true"
      :showAdd="true"
      :columnData="columns"
      :data="data"
      @addDiolog="addDiolog()"
      @rowAction="rowActions($event)"
      activity="udf"

    />
  
    <v-dialog persistent v-model="dialog" width="550px">
      <CreateUdfs
        @closeDialog="close()"
        @reload="getUdfsData()"
        :id="editId"
        :viewType="viewType"
      />
    </v-dialog>
  </template>
    
    <script>
  import CreateUdfs from "./CreateUdfs.vue";
  import PrimeDataTable from "@/components/PrimeDataTable";
  import udfservice from "@/api/service/Udfs/UdfsService.js";
  export default {
    components: {
      CreateUdfs,
      PrimeDataTable,
    },
    data() {
      return {
        data: [],
        columns: [],
        date: new Date(),
        editId: null,
        dialog: false,
        viewType: false,
      };
    },
    created() {
      this.loadColumns();
      this.download = true;
      this.search = true;
      this.checkbox = true;
      this.getUdfsData();
    },
    methods: {
      loadColumns() {
        this.columns = [
          {
            field: "code",
            header: "Code",
            style: { width: "100px", color: "" },
            toolTip: "Code",
            sortfield: true,
          },
          {
            field: "name",
            header: "Name",
            style: { width: "100px", color: "" },
            toolTip: "Name",
            sortfield: true,
          },
          {
          field: "status",
          header: "Status",
          style: { width: "100px", color: "" },
          toolTip: "Status",
          sortfield: true,
          },
          {
            field: "action",
            header: "Action",
            style: { width: "100px", color: "" },
            toolTip: "Action",
            sortfield: false,
            rowActions: [{ action: "view" }, { action: "edit" }],
          },
        ];
      },
      rowActions($event) {
        if ($event.type == "view") {
          this.dialog = true;
          this.editId = $event.data.id;
          this.viewType = $event.type;
        }
        if ($event.type == "edit") {
          this.dialog = true;
          this.editId = $event.data.id;
          this.viewType = $event.type;
        }
  
        if ($event.type == "select") {
          this.dialog = true;
          this.editId = $event.data.id;
          this.viewType = "view";
        }
      },
      async getUdfsData() {
        let res = await udfservice.findAll();
        this.data = res;
        console.log(this.data, "kassss");
      },
      
      close() {
        this.dialog = false;
      },
      addDiolog() {
        this.dialog = true;
        this.editId = null;
        this.viewType = false;
      },
    },
  };
  </script>
    
    
    